module.exports = __webpack_public_path__ + "static/media/close.53532c3c.svg";